// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const tangrowth: PokeData = {
  "id": 465,
  "name": "tangrowth",
  "height": 20,
  "weight": 1286,
  "base_experience": 187,
  "types": [
    PokeType.GRASS
  ],
  "api_moves": [
    "bind",
    "slam",
    "vine-whip",
    "absorb",
    "mega-drain",
    "growth",
    "poison-powder",
    "stun-spore",
    "sleep-powder",
    "constrict",
    "sludge-bomb",
    "giga-drain",
    "ancient-power",
    "ingrain",
    "knock-off",
    "tickle",
    "block",
    "natural-gift",
    "wring-out",
    "energy-ball",
    "power-whip",
    "double-hit",
    "acid-spray",
    "grassy-terrain"
  ],
  "moves": [
    "vine-whip",
    "poison-powder",
    "stun-spore",
    "sludge-bomb",
    "ancient-power",
    "energy-ball",
    "power-whip",
    "grassy-terrain",
    "bullet-seed",
    "branch-poke",
    "flower-rush",
    "frenzy-plant",
    "razor-leaf"
  ],
  "evolution_chain": {
    "id": 52,
    "item": null,
    "species": [
      {
        "name": "tangela",
        "order": 129,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "tangrowth",
        "order": 130,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": 114,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": {
              "name": "ancient-power"
            },
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 148,
    "speed": 79,
    "ability_power": 173
  },
  "stat_changes": [],
  "catch_rate": 30,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
